import React, { useContext, useState } from "react";
import { StyleSheet, Image, TouchableOpacity, ScrollView, Platform } from "react-native";
import * as Yup from "yup";
import configurationPost from "../config/configurationPost";
import * as ImageManipulator from "expo-image-manipulator";
import { MaterialCommunityIcons, AntDesign } from "@expo/vector-icons";
import Screen from "../components/Screen";
import {
  ErrorMessage,
  Form,
  FormField,
  SubmitButton,
} from "../components/forms";
//import useAuth from "../auth/useAuth";
import * as ImagePicker from "expo-image-picker"
import connectionConfig from "../config/settings";
import dateNow from "../utility/dateNow";
import UploadScreen from "./UploadScreen";
import routes from "../navigation/routes";
import colors from "../config/colors";
import { useEffect } from "react/cjs/react.development";
import createNotification from "../utility/createNotification";
import AuthContext from "../auth/context";

var date = dateNow()

const validationSchema = Yup.object().shape({
  seedName: Yup.string().required().max(100).label("Título de la semilla"),
  seedDescription: Yup.string().required().max(500).label("Descripción de la semilla"),
});

function ListingEditScreen(props) {

  var nameDateImageAndVideo = ''
  var typeFileImageAndVideo = ''

  useEffect(() => {
    date = dateNow()
  }, [])

  const { user } = useContext(AuthContext);

  const [progress, setProgress] = useState(0);
  const [imageUri, setImageUri] = useState('');
  const [uploadVisible, setUploadVisible] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleSubmit = async (listing, { resetForm }) => {
    //debugger
    resetForm()
    //Valida si es imagen o video lo que se eligio
    if (imageUri != '') {
      if (imageUri.includes('.jpg')) {
        typeFileImageAndVideo = 'image/jpeg'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.jpg'
      }
      if (imageUri.includes('.mp4')) {
        typeFileImageAndVideo = 'application/mp4'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mp4'
      }
      if (imageUri.includes('.mov')) {
        typeFileImageAndVideo = 'video/quicktime'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mov'
      }
    }

    var post_values = {
      seedName: listing.seedName,
      seedDescription: listing.seedDescription,
      seedPhoto: nameDateImageAndVideo,
      userId: JSON.parse(user).userId,
      createDateSeed: date,
      type: -1 // es el identificador para publicaión
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/insertPublication/', configurationPost)
      .then(response => response.json())
      .then(response => {
        setProgress(1);
        setUploadVisible(true)
        if (imageUri != '') {
          savePhoto()

        }
        var descripNotification = JSON.parse(user).userName + ' creó una nueva publicación'
        var seedId = response.data.insertId
        var userId = JSON.parse(user).userId
        var notificationTypeId = 1
        var CompOrigin = 'AddSeed'
        createNotification.insertNotification(descripNotification, seedId, userId, notificationTypeId, CompOrigin)
        props.navigation.navigate(routes.NO_BOTTON)
      })
      .catch(err => {
        console.log('update fixo failed :( review internet service /insertSeed/', err)
      })

  };

  //--------------------------------------------- 
  //Rutina para guardar una foto o video
  //---------------------------------------------
  const savePhoto = async () => {
    let format = 'JPEG'
    let quality = 0.1


    if (Platform.OS === 'android') {
      quality = 0.5

    } else {
      quality = 0.05
    }

    //debugger
    try {
      const formData = new FormData()
      if (typeFileImageAndVideo === 'image/jpeg') {
        const manipResult = await ImageManipulator.manipulateAsync(
          imageUri,
          [],
          { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
        formData.append('photoAndVideo', {
          uri: manipResult.uri,
          type: typeFileImageAndVideo,
          name: nameDateImageAndVideo,
        })
      }
      if (typeFileImageAndVideo === 'application/mp4') {
        formData.append('photoAndVideo', {
          uri: imageUri,
          type: typeFileImageAndVideo,
          name: nameDateImageAndVideo,
        })
      }
      if (typeFileImageAndVideo === 'video/quicktime') {
        formData.append('photoAndVideo', {
          uri: imageUri,
          type: typeFileImageAndVideo,
          name: nameDateImageAndVideo,
        })
      }
      const configurationPost = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
        body: formData
      }
      // post Para guardar imagen de perfil
      fetch(connectionConfig.apiUrl + '/upload_infoPhotoAndVideo', configurationPost)
        .then(response => response.json())
        .then(response => {
          //debugger
          setProgress(1)
          setImageUri('')
          typeFileImageAndVideo = ''
          nameDateImageAndVideo = ''

          if (response.data === 'descarga-> error') {
            console.log("maintennance server descarga-> error /upload_infoPhotoAndVideo")
          }
        })
        .catch((err) => {
          alert("Entre en el penultimo catch de addseed", err)
          setProgress(1)
          console.log("maintennance server -> catch /upload_infoPhotoAndVideo", err)
        })
    } catch (error) {
      alert("Entre en último catch de addseed", err)
      setProgress(1)
      console.log("maintennance server -> catch Final /upload_infoPhotoAndVideo", error)
    }
  }

  //--------------------------------------------------
  //  Select Image es la función que te permite sacar
  //  la biblioteca de imagenes de tu Cel 
  //--------------------------------------------------
  const selectImage = async () => {
    try {
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.All,
        allowsEditing: true,
        aspect: [4, 3],
        //quality: 0,
      })
      if (!result.cancelled)
        setImageUri(result.uri)
    } catch (error) {
      console.log("error al leer imagen", error)
    }
  }

  return (

    <Screen style={styles.container}>
      <ScrollView>
        <UploadScreen
          onDone={() => setUploadVisible(false)}
          progress={progress}
          visible={uploadVisible}
        />
        <TouchableOpacity style={styles.image} onPress={selectImage}>
          {imageUri != '' ?
            <Image style={styles.imagePhoto} source={{ uri: imageUri }} />
            :
            <MaterialCommunityIcons
              //style={styles.image}
              name="camera"
              size={150}
              color={colors.medium}
            />
          }
        </TouchableOpacity>


        <Form
          initialValues={{ seedName: "", seedDescription: "" }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <ErrorMessage
            error="Invalid email and/or password."
            visible={visible}
          />
          <FormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="account-edit"
            name="seedName"
            placeholder="Title"
            maxLength={100}
          />
          <FormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="account-edit"
            name="seedDescription"
            placeholder="Description"
            maxLength={3000}
          />
          <SubmitButton title="Save" />
        </Form>
      </ScrollView>
    </Screen >
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 10,
  },
  image: {
    width: 200,
    alignSelf: "center",
    alignItems: "center",
    borderRadius: 5,
  },
  imagePhoto: {
    width: 200,
    height: 200,
    alignSelf: "center",
    marginBottom: "4%",
    borderRadius: 5,
  },
  touchable: {
    position: "absolute",
    marginLeft: "57%",//20,
    marginTop: "30%"//110
  },
  containerYoutubeLink: {
    marginTop: "5%",
    flexDirection: "row",
    justifyContent: 'space-evenly',
    backgroundColor: colors.light,
    padding: "2%",
    borderRadius: 30,
  },
  input: {
    borderColor: colors.medium,
    //backgroundColor: colors.light,
    fontSize: 17,
    color: "#202731",
    width: "85%",
  },
  iconYoutube: {
    alignSelf: "center",
    padding: "2%",
    borderRadius: 11,
    justifyContent: "center",
    alignItems: "center",
    marginRight: "5%",
    marginLeft: "4%",
  },
  icon: {
    alignSelf: "center",
    margin: 10,
    width: "10%",
  },
  pdfIcon: {
    marginLeft: "10%",
    width: "10%",
  },
  visorYoutube: {
    width: "90%",
    marginTop: "4%",
    marginLeft: "5%",
  }
});

export default ListingEditScreen;